export const groupByBannerActions = {
  startLoader: "START_GROUP_BY_BANNERS_LOADER",
  success: "GROUP_BY_BANNERS_SUCCESS",
  failure: "GROUP_BY_BANNERS_FAILURE"
};
